import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export const getTrainerFieldContentOrNumber = (
  field: string,
  trainer: racehorse360.ITrainer
): string => {
  if (!trainer) return;

  return field.trim() || getTrainerTypeAndNumber(trainer);
};

export const getTrainerTypeAndNumber = (
  trainer: racehorse360.ITrainer
): string =>
  trainer.type
    ? `${trainer.type}-` + `${trainer.trainerNumber}`.toLowerCase()
    : `${trainer.trainerNumber}`.toLowerCase();
